import { Link } from "react-router";
import { formatVnd } from "../../shared/i18n/index.ts";
import type { Segment } from "../../shared/price.ts";
import type { ListingCard as Card } from "../../shared/types.ts";
import { tickStagger } from "../lib/clock.ts";
import { useI18n } from "../lib/i18n.tsx";
import { Counts } from "./Counts.tsx";
import { PriceDisplay } from "./PriceDisplay.tsx";
import { TimeBucket } from "./TimeBucket.tsx";

/** Card (08-design.md §Components). `segment` overrides the payload one when a fresher poll exists. */
export function ListingCard({ card, segment }: { card: Card; segment?: Segment }) {
  const { t } = useI18n();
  const seg = segment ?? card.segment;
  const preview = seg.status === "scheduled";
  return (
    <article className="card" data-testid="listing-card">
      <Link to={`/l/${card.id}`} className="card__link">
        {card.cover ? (
          <img className="card__cover" src={card.cover} alt="" loading="lazy" />
        ) : (
          <div className="card__cover" />
        )}
        {card.is_drop ? (
          <span className="tag tag--drop card__tag">{t("listing.drop_tag")}</span>
        ) : null}
        <div className="card__body">
          <h3 className="card__title">{card.title}</h3>
          <p className="card__meta">
            {card.condition ? t(`listing.condition.${card.condition}`) : ""}
            {card.district ? ` · ${card.district}` : ""}
          </p>
          {preview ? (
            <>
              <span className="price price--sm price--far">
                <span className="price__value">{formatVnd(card.start_price)}</span>
              </span>
              <span className="hint">
                {t("listing.starts_at_drop", { when: t("drop.time_label") })}
              </span>
            </>
          ) : (
            <>
              <PriceDisplay segment={seg} size="sm" stagger={tickStagger(card.id)} />
              <div className="card__foot">
                <TimeBucket bucket={seg.bucket} />
                <Counts watching={card.counts.watching} alerts={card.counts.alerts} />
              </div>
            </>
          )}
        </div>
      </Link>
    </article>
  );
}
